import {Loader, Select, Text} from '@mantine/core';
import type {FC} from 'react';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';
import {SelectedInfoBox} from './SelectedInfoBox';

type Props = {
  onBack: () => void;
  onSubmit: () => void;
  stepOptions: {value: string; label: string}[];
  selectedStep: string;
  onStepChange: (value: string | null) => void;
  isGenerating: boolean;
  companyName: string;
  departmentLabel: string;
  selectedStepLabel: string;
};

export const AiTodoStepSelectContent: FC<Props> = ({
  onBack,
  onSubmit,
  stepOptions,
  selectedStep,
  onStepChange,
  isGenerating,
  companyName,
  departmentLabel,
  selectedStepLabel,
}) => {
  if (isGenerating) {
    return (
      <div className="flex flex-col items-center gap-16 p-16">
        <SelectedInfoBox
          companyName={companyName}
          departmentLabel={departmentLabel}
          stepName={selectedStepLabel}
        />
        <Loader />
        <Text className="text-black-2 text-center">
          選考予定に関連するToDoを自動生成しています...
          <br />
          結果を表示するにはページに留まってください
        </Text>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-24">
      <SelectedInfoBox
        companyName={companyName}
        departmentLabel={departmentLabel}
      />
      <div className="flex flex-col gap-8">
        <Text className="text-sm text-black-2">
          ToDo生成対象のステップを選択してください
        </Text>
        <Select
          placeholder="選択してください"
          data={stepOptions}
          value={selectedStep}
          onChange={onStepChange}
          maxDropdownHeight={300}
          withinPortal
          styles={{
            input: {
              borderRadius: '12px',
            },
          }}
        />
      </div>
      <div className="flex items-center justify-center gap-16">
        <ModalCancelButton onClick={onBack}>戻る</ModalCancelButton>
        <ModalSubmitButton onClick={onSubmit} disabled={!selectedStep}>
          生成する
        </ModalSubmitButton>
      </div>
    </div>
  );
};
